import React, { Component } from "react";
import { Router, Route } from "react-router-dom";
import createBrowserHistory from "history/createBrowserHistory";
import { connect } from "react-redux";

import { deselectAll } from "../../actions/select_actions";

import Toolbar from "./_Toolbar";

import Home from "./Static/Home";
import Services from "./Static/Services";
import Contacts from "./Static/Contacts";


import Login from "./Login";
import Planning from "../Planning";
import Relations from "../Relations";
import Orders from "../Orders";
import Shipments from "../Shipments";
import Carriers from "../Carriers";
import Seller from "../Seller";
import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";

const locationHelper = locationHelperBuilder({});

const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: "/login", // TODO add fault page
  authenticatedSelector: state =>
    state.auth.authenticated === true && state.auth.role !== "seller",
  wrapperDisplayName: "UserIsAuthenticated"
});

const userIsAuthenticatedSeller = connectedRouterRedirect({
  redirectPath: "/seller", // TODO add fault page
  authenticatedSelector: state =>
    state.auth.authenticated === true && state.auth.role === "seller",
  wrapperDisplayName: "UserIsAuthenticatedSeller"
});

const userIsNotAuthenticated = connectedRouterRedirect({
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || "/login",
  allowRedirectBack: false,
  authenticatedSelector: state => state.auth.authenticated === false,
  wrapperDisplayName: "UserIsNotAuthenticated"
});

const history = createBrowserHistory();

class Routes extends Component {
  render() {
    history.listen((location, action) => {
      this.props.deselectAll();
    });

    return (
      <Router history={history}>
        <div style={{ height: "100vh" }}>
          <Toolbar />
          <Route exact path="/" component={Home} />
          <Route path="/services" component={Services} />
          <Route path="/contacts" component={Contacts} />
          <Route path="/seller" component={userIsAuthenticatedSeller(Seller)} />
          <Route path="/login" component={userIsNotAuthenticated(Login)} />
          <Route path="/planning" component={userIsAuthenticated(Planning)} />
          <Route path="/relations" component={userIsAuthenticated(Relations)} />
          <Route path="/orders" component={userIsAuthenticated(Orders)} />
          <Route path="/shipments" component={userIsAuthenticated(Shipments)} />
          <Route path="/carriers" component={userIsAuthenticated(Carriers)} />
        </div>
      </Router>
    );
  }
}

export default connect(state => state.auth, { deselectAll: deselectAll })(
  Routes
);



// WEBPACK FOOTER //
// ./src/views/App/Routes.js